/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewsubjectpt4Inputs */

const en_letterpreviewsubjectpt4 = /** @type {(inputs: Letterpreviewsubjectpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assunto: Interpelação amigável — obra contratada`)
};

const pt_letterpreviewsubjectpt4 = /** @type {(inputs: Letterpreviewsubjectpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assunto: Interpelação amigável — obra contratada`)
};

/**
* | output |
* | --- |
* | "Assunto: Interpelação amigável — obra contratada" |
*
* @param {Letterpreviewsubjectpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsubjectpt4 = /** @type {((inputs?: Letterpreviewsubjectpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsubjectpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsubjectpt4(inputs)
	return pt_letterpreviewsubjectpt4(inputs)
});
export { letterpreviewsubjectpt4 as "letterPreviewSubjectPT" }